import ApiClient from './ApiClient';

class AccountStatusesAPI extends ApiClient {
  constructor() {
    super('account_statuses', { accountScoped: true });
  }
}

export default new AccountStatusesAPI();
